export default {
  ticketList: state => state.ticketList,
  blockList: state => state.blockList,
  generalConfig: state => state.generalConfig,
  checkoutConfig: state => state.checkoutConfig,
  keyStorage: state => state.keyStorage,
  workingHour: state => state.workingHour,
  bookingWorkingHour: state => state.bookingWorkingHour,
  smsContent: state => state.smsContent,
  policyData: state => state.policyData,
  taxSetting: state => state.taxSetting,
  tipSetting: state => state.tipSetting,
  serviceFee: state => state.serviceFee,
  storeRating: state => state.storeRating,
  countryCode: state => state.countryCode,
  isInGermany: state => state.countryCode === 'DE',
}
